import React from "react";
import {IconButton, useColorMode} from "@chakra-ui/core";

import {useTranslation} from "~/i18n/hooks";

// Sits over the banner, so it keeps its own contrast in both modes
const ColorModeToggle: React.FC = () => {
  const t = useTranslation();
  const {colorMode, toggleColorMode} = useColorMode();

  return (
    <IconButton
      _hover={{backgroundColor: "blackAlpha.600"}}
      aria-label={t("common.toggleColorMode")}
      backgroundColor="blackAlpha.500"
      color="white"
      icon={colorMode === "dark" ? "sun" : "moon"}
      isRound
      position="absolute"
      right={2}
      size="sm"
      top={2}
      variant="ghost"
      zIndex={1}
      onClick={toggleColorMode}
    />
  );
};

export default ColorModeToggle;
